import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=129c8360&scoped=true"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"
import style0 from "./creation.vue?vue&type=style&index=0&id=129c8360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c8360",
  null
  
)

export default component.exports